import template from './clipButton.component.html';

const BROWSERS = {
  Chrome: 'https://www.google.com/chrome',
  Firefox: 'https://www.mozilla.org/firefox',
  Edge: 'https://www.microsoft.com/en-us/windows/microsoft-edge'
};


/* @ngInject */
function controller(clipboard, growl) {
  const vm = this;

  vm.$onInit = $onInit;
  vm.copyToClipboard = copyToClipboard;

  function $onInit() {
    vm.btn = `btn-${vm.size || 'sm'}`;
    vm.icon ||= 'fal fa-copy';
  }


  function copyToClipboard(event) {
    event.preventDefault();
    event.stopPropagation();
    if (clipboard.supported) {
      clipboard.copyText(vm.txt);
      growl.success('Copied to clipboard');
    } else {
      growl.error(
        `Upgrade to a modern browser for the best experience: ${
          _.map(BROWSERS, (url, name) => `<a href=${url} target=_blank rel=noreferrer>${name}</a>`).join(', ')
        }`,
        { title: 'Browser not supported!', ttl: -1 });
    }
  }
}

export default {
  name: 'clipButton',
  template,
  controller,
  bindings: {
    icon: '@?',
    label: '@?',
    // btn-? (xs|sm|lg)
    size: '@?',
    txt: '@',
  }
};
